import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { urlJoin } from '../helpers/url.helper';
import { catchError, map, Observable, of } from 'rxjs';
import { AppConfig } from '../../app.config';

@Injectable({
  providedIn: 'root'
})
export class OpenBankingService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly appConfig: AppConfig = inject(AppConfig);

  openBankingNotificationExists(externalId: string): Observable<boolean> {
    const url = urlJoin(this.appConfig.mobiSubBackUrl, `leads/${externalId}/open-banking`);
    return this.httpClient.get<void>(url).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }
}
